import { StorageService } from './interfaces/storage.service';

export class LocalStorageService implements StorageService {

  private readonly STORAGE_KEYS_PREFIX = 'epb-';

  private isSupported: boolean;

  constructor() {
    this.isSupported = LocalStorageService.checkSupport();
  }

  private static checkSupport(): boolean {
    // Using Modernizr's feature detection to check for localStorage support:
    // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/storage/localstorage.js
    const testItem = 'localstorage-test-item';
    try {
      localStorage.setItem(testItem, testItem);
      localStorage.removeItem(testItem);
      return true;
    } catch (error) {
      return false;
    }
  }

  public getItem(key: string): string {
    if (this.isSupported) {
      return localStorage.getItem(this.getStorageKey(key));
    }
  }

  public setItem(key: string, value: string): void {
    if (this.isSupported) {
      localStorage.setItem(this.getStorageKey(key), value);
    }
  }

  public removeItem(key: string): void {
    if (this.isSupported) {
      localStorage.removeItem(this.getStorageKey(key));
    }
  }

  private getStorageKey(key: string): string {
    return `${this.STORAGE_KEYS_PREFIX}${key}`;
  }

}
